import React from 'react';
import { useFolderLabel } from '../../hooks/useFolderLabel';
import { FolderManagementModal } from '../modals/folders/FolderManagementModal';
import { FolderLabelTemplate } from '../templates/folder-label/FolderLabelTemplate';

const FolderLabelUIPage: React.FC = () => {
    const {
        tabs,
        activeTab,
        setActiveTab,
        selectedCompany,
        tabContent,
        showFolderModal,
        openFolderModal,
        closeFolderModal,
        folders,
        companyMappings,
        addFolder,
        deleteFolder,
        addSubfolder,
    } = useFolderLabel();

    return (
        <FolderLabelTemplate
            title="Your Proprietary Data Index"
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={setActiveTab}
            tabContent={tabContent}
            onManageFoldersClick={openFolderModal}
        >
            <FolderManagementModal
                open={showFolderModal}
                onClose={closeFolderModal}
                folders={folders}
                onAddFolder={addFolder}
                onDeleteFolder={deleteFolder}
                onAddSubfolder={addSubfolder}
                selectedCompany={selectedCompany}
                companyMappings={companyMappings}
            />
        </FolderLabelTemplate>
    );
};

export default FolderLabelUIPage;
